/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum Period {
    CurrentMonth = 1,
    LastMonth,
    Last30Days,
}
